import { Fade } from "react-reveal";

const categories = [
    {
        label: "Programing",
        skills: [
            {
                label: "Python",
                icon: "python-plain",
                value: "90",
                details: "Advanced",
                color: "red"
            },
            {
                label: "SQL",
                value: "90",
                details: "Advanced",
                color: "yellow"
            },
            {
                label: "Js",
                icon: "javascript-plain",
                value: "75",
                details: "Intermediate",
                color: "green"
            },
            {
                label: "Java",
                icon: "java-plain",
                value: "50",
                details: "Intermediate",
                color: "blue"
            },
            {
                label: "C/C++",
                icon: "c-plain",
                value: "30",
                details: "Basics",
                color: "purple"
            },
            {
                label: "Go",
                icon: "go-plain",
                value: "30",
                details: "Basics",
                color: "red"
            }
        ]
    },
    {
        label: "Expertise",
        skills: [
            {
                label: "Data Processing",
                value: "90",
                details: "Pandas, Numpy, PySpark",
                color: "red"
            },
            {
                label: "Machine Learning",
                value: "90",
                details: "Probabilistic, Decision Trees, Boosting",
                color: "yellow"
            },
            {
                label: "Deep Learning",
                value: "90",
                details: "CNN, LSTM, AE/VAE, GAN, Transformers",
                color: "green"
            },
            {
                label: "Dataviz",
                value: "80",
                details: "Tableau, PowerBI",
                color: "blue"
            },
            {
                label: "Web Semantic",
                value: "80",
                details: "RDF/RDFS, OWL, RML, SPARQL",
                color: "purple"
            },
            {
                label: "Cloud Computing",
                value: "75",
                details: "Google Cloud",
                color: "red"
            },
            {
                label: "Process Mining",
                value: "75",
                details: "PM4PY",
                color: "yellow"
            }
        ]
    },
    {
        label: "Frameworks",
        skills: [
            {
                label: "Tensorflow",
                icon: "tensorflow-original",
                value: "85",
                details: "Advanced",
                color: "red"
            },
            {
                label: "React",
                icon: "react-plain",
                value: "85",
                details: "Advanced",
                color: "yellow"
            },
            {
                label: "Flutter",
                icon: "flutter-plain",
                value: "70",
                details: "Intermediate",
                color: "green"
            },
            {
                label: "PyTorch",
                icon: "pytorch-plain",
                value: "50",
                details: "Intermediate",
                color: "blue"
            },
            {
                label: "Django",
                icon: "django-plain",
                value: "30",
                details: "Basics",
                color: "purple"
            },
        ]
    }
]

const certificates = [
    {
        label: "Deep Learning AI NLP Specialization",
        icon: <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24" id="coursera"><polygon points="23.974 11.653 23.973 11.646 23.974 11.657"></polygon><path fill="#0068B0" d="M6.268,18.242c0.117,0.005,0.234,0.008,0.352,0.008c1.045,0,2.011-0.189,2.878-0.569c0.217-0.095,0.427-0.205,0.641-0.329c0.117-0.068,0.229-0.142,0.338-0.219l0.08-0.056l0.137-0.095c0.164-0.12,0.317-0.25,0.467-0.388l0.052-0.051l0.259-0.26l0.31-0.359l0.118-0.151l0.057-0.083l0.055-0.08c0.462-0.791,1.965-3.672,1.965-3.672v-0.006l0.09-0.175l0.074-0.138c0.222-0.411,0.382-0.703,0.594-1.009l0.006-0.01c0.493-0.731,1.344-1.251,2.346-1.339c1.68-0.148,3.151,0.978,3.286,2.513c0.135,1.536-1.116,2.902-2.797,3.05c-0.087,0.008-0.189,0.013-0.292,0.013c-0.255,0-0.503-0.029-0.742-0.083l0.024,0.004l-0.01,0.003c-1.231-0.262-2.016-1.178-2.403-1.589l-1.617,3.033c0,0,0.503,0.516,0.847,0.774c0.346,0.258,0.79,0.511,1.146,0.669c0.836,0.38,1.812,0.6,2.838,0.6c0.121,0,0.097,0,0.222-0.005c1.844-0.078,3.488-0.799,4.675-2.034c1.122-1.172,1.733-2.511,1.738-4.097v-0.048l-0.011-0.262v0.001c-0.004-0.107-0.01-0.205-0.02-0.3c-0.095-1.068-0.447-2.037-0.991-2.862c-0.261-0.396-0.546-0.742-0.862-1.054l-0.002-0.002c-0.469-0.457-1.01-0.842-1.602-1.136l-0.037-0.016c-0.875-0.43-1.903-0.681-2.987-0.681h-0.063h-0.003h-0.027c-0.886,0-1.733,0.161-2.52,0.454c-0.693,0.251-1.293,0.592-1.824,1.019c-0.12,0.1-0.228,0.195-0.33,0.293l0.004-0.003l-0.085,0.087L12.521,7.73h0.001l-0.055,0.056l-0.026,0.029L12.3,7.965c-0.105,0.119-0.202,0.238-0.296,0.356V8.318L12,8.315c-0.193,0.238-0.37,0.485-0.5,0.707c-0.09,0.143-0.177,0.288-0.26,0.436l-1.146,2.365l0.002,0.001l-0.059,0.12L9.91,12.204c-0.251,0.519-0.521,1.037-0.821,1.463c-0.672,0.751-1.431,1.12-2.405,1.12l-0.209-0.008c-0.588-0.024-1.092-0.166-1.539-0.436c-0.423-0.251-0.761-0.608-0.987-1.036l-0.007-0.014c-0.206-0.376-0.328-0.826-0.328-1.304l0.002-0.097v0.005l0.002-0.035c0.031-0.775,0.321-1.378,0.904-1.897c0.142-0.127,0.291-0.232,0.447-0.326l0.064-0.037C5.467,9.36,5.959,9.24,6.524,9.24L6.7,9.246c0.899,0.035,1.592,0.32,2.145,0.88l1.734-3.175c-0.403-0.275-0.864-0.519-1.353-0.707L9.18,6.227L9.12,6.204L8.933,6.139C8.432,5.963,7.849,5.838,7.245,5.785L7.218,5.784L7.162,5.777l-0.265-0.02C6.814,5.754,6.709,5.751,6.605,5.75H6.6H6.545H6.507c-1.072,0-2.085,0.247-2.993,0.685C2.484,6.941,1.64,7.693,1.03,8.619L1.016,8.642C0.38,9.599,0,10.779,0,12.05v0.039c-0.002,1.595,0.568,2.996,1.701,4.173C2.885,17.498,4.422,18.164,6.268,18.242L6.268,18.242z"></path><polygon points="23.972 11.637 23.973 11.642 23.973 11.646"></polygon><polygon points="3.477 6.688 3.514 6.672 3.518 6.67"></polygon><polygon points="7.145 6.153 7.163 6.155 7.174 6.156"></polygon><polygon points="13.045 7.551 13.051 7.547 13.058 7.541"></polygon><polygon points="14.829 6.583 14.875 6.568 14.88 6.566"></polygon><polygon points="22.971 8.818 22.981 8.835 22.984 8.839"></polygon><path fill="#005B99" d="M16.542,14.753c0.007,0.002,0.015,0.003,0.022,0.005l0.001,0L16.542,14.753L16.542,14.753z M13.945,12h-3.936L9.91,12.204c-0.251,0.519-0.521,1.037-0.821,1.463c-0.672,0.751-1.431,1.12-2.405,1.12l-0.209-0.008c-0.588-0.024-1.092-0.166-1.539-0.436c-0.423-0.251-0.761-0.608-0.987-1.036l-0.007-0.014C3.737,12.92,3.615,12.474,3.613,12H0c0,0.017,0,0.033,0,0.05v0.039c-0.002,1.595,0.568,2.996,1.701,4.173c1.183,1.235,2.721,1.901,4.566,1.979c0.117,0.005,0.234,0.008,0.352,0.008c1.045,0,2.011-0.189,2.878-0.569c0.217-0.095,0.427-0.205,0.641-0.329c0.117-0.068,0.229-0.142,0.338-0.219l0.08-0.056l0.137-0.095c0.164-0.12,0.317-0.25,0.467-0.388l0.052-0.051l0.259-0.26l0.31-0.359l0.118-0.151l0.057-0.083l0.055-0.08C12.435,14.888,13.724,12.423,13.945,12L13.945,12z M23.998,12h-3.614c0.001,1.442-1.209,2.683-2.807,2.824c-0.087,0.008-0.189,0.013-0.292,0.013c-0.247,0-0.488-0.027-0.72-0.078l-0.008,0.002c-1.231-0.262-2.016-1.178-2.403-1.589l-1.617,3.033c0,0,0.503,0.516,0.847,0.774c0.346,0.258,0.79,0.511,1.146,0.669c0.836,0.38,1.812,0.6,2.838,0.6c0.121,0,0.097,0,0.222-0.005c1.844-0.078,3.488-0.799,4.675-2.034c1.122-1.172,1.733-2.511,1.738-4.097v-0.048L23.998,12L23.998,12z"></path></svg>,
        date: "May 2023",
        link: "https://www.coursera.org/account/accomplishments/specialization/certificate/ZL48TELWMCJ2"
    },
    {
        label: "TensorFlow on Google Cloud",
        icon: (
            <svg viewBox="0 0 128 128">
            <path fill="#ea4535" d="M80.6 40.3h.4l-.2-.2 14-14v-.3c-11.8-10.4-28.1-14-43.2-9.5C36.5 20.8 24.9 32.8 20.7 48c.2-.1.5-.2.8-.2 5.2-3.4 11.4-5.4 17.9-5.4 2.2 0 4.3.2 6.4.6.1-.1.2-.1.3-.1 9-9.9 24.2-11.1 34.6-2.6h-.1z"></path><path fill="#557ebf" d="M108.1 47.8c-2.3-8.5-7.1-16.2-13.8-22.1L80 39.9c6 4.9 9.5 12.3 9.3 20v2.5c16.9 0 16.9 25.2 0 25.2H63.9v20h-.1l.1.2h25.4c14.6.1 27.5-9.3 31.8-23.1 4.3-13.8-1-28.8-13-36.9z"></path><path fill="#36a852" d="M39 107.9h26.3V87.7H39c-1.9 0-3.7-.4-5.4-1.1l-15.2 14.6v.2c6 4.3 13.2 6.6 20.7 6.6z"></path><path fill="#f9bc15" d="M40.2 41.9c-14.9.1-28.1 9.3-32.9 22.8-4.8 13.6 0 28.5 11.8 37.3l15.6-14.9c-8.6-3.7-10.6-14.5-4-20.8 6.6-6.4 17.8-4.4 21.7 3.8L68 55.2C61.4 46.9 51.1 42 40.2 42.1z"></path>
            </svg>
        ),
        date: "April 2023",
        link: "https://www.coursera.org/account/accomplishments/certificate/SM52MJAFJWTM"
    },
    {
        label: "Google Cloud Big Data and Machine Learning Fundamentals",
        icon: (
            <svg viewBox="0 0 128 128">
            <path fill="#ea4535" d="M80.6 40.3h.4l-.2-.2 14-14v-.3c-11.8-10.4-28.1-14-43.2-9.5C36.5 20.8 24.9 32.8 20.7 48c.2-.1.5-.2.8-.2 5.2-3.4 11.4-5.4 17.9-5.4 2.2 0 4.3.2 6.4.6.1-.1.2-.1.3-.1 9-9.9 24.2-11.1 34.6-2.6h-.1z"></path><path fill="#557ebf" d="M108.1 47.8c-2.3-8.5-7.1-16.2-13.8-22.1L80 39.9c6 4.9 9.5 12.3 9.3 20v2.5c16.9 0 16.9 25.2 0 25.2H63.9v20h-.1l.1.2h25.4c14.6.1 27.5-9.3 31.8-23.1 4.3-13.8-1-28.8-13-36.9z"></path><path fill="#36a852" d="M39 107.9h26.3V87.7H39c-1.9 0-3.7-.4-5.4-1.1l-15.2 14.6v.2c6 4.3 13.2 6.6 20.7 6.6z"></path><path fill="#f9bc15" d="M40.2 41.9c-14.9.1-28.1 9.3-32.9 22.8-4.8 13.6 0 28.5 11.8 37.3l15.6-14.9c-8.6-3.7-10.6-14.5-4-20.8 6.6-6.4 17.8-4.4 21.7 3.8L68 55.2C61.4 46.9 51.1 42 40.2 42.1z"></path>
            </svg>
        ),
        date: "March 2023",
        link: "https://www.coursera.org/account/accomplishments/certificate/RGCL5AKHXS4P"
    },
    {
        label: "How Google does Machine Learning",
        icon: (
            <svg viewBox="0 0 128 128">
            <path fill="#ea4535" d="M80.6 40.3h.4l-.2-.2 14-14v-.3c-11.8-10.4-28.1-14-43.2-9.5C36.5 20.8 24.9 32.8 20.7 48c.2-.1.5-.2.8-.2 5.2-3.4 11.4-5.4 17.9-5.4 2.2 0 4.3.2 6.4.6.1-.1.2-.1.3-.1 9-9.9 24.2-11.1 34.6-2.6h-.1z"></path><path fill="#557ebf" d="M108.1 47.8c-2.3-8.5-7.1-16.2-13.8-22.1L80 39.9c6 4.9 9.5 12.3 9.3 20v2.5c16.9 0 16.9 25.2 0 25.2H63.9v20h-.1l.1.2h25.4c14.6.1 27.5-9.3 31.8-23.1 4.3-13.8-1-28.8-13-36.9z"></path><path fill="#36a852" d="M39 107.9h26.3V87.7H39c-1.9 0-3.7-.4-5.4-1.1l-15.2 14.6v.2c6 4.3 13.2 6.6 20.7 6.6z"></path><path fill="#f9bc15" d="M40.2 41.9c-14.9.1-28.1 9.3-32.9 22.8-4.8 13.6 0 28.5 11.8 37.3l15.6-14.9c-8.6-3.7-10.6-14.5-4-20.8 6.6-6.4 17.8-4.4 21.7 3.8L68 55.2C61.4 46.9 51.1 42 40.2 42.1z"></path>
            </svg>
        ),
        date: "March 2023",
        link: "https://www.coursera.org/account/accomplishments/certificate/6YXNTB8S8DRH"
    },
    {
        label: "Process Mining: Data science in Action",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" id="university"><path fill="#e8aa60" d="M32.73 15h-1.46V.73c0-.4.33-.73.73-.73.4 0 .73.33.73.73V15z"></path><path fill="#51bf9f" d="M42.71 7.62c-3.99-3.63-5.99 3.63-9.98 0V1.05c3.99 3.63 5.99-3.63 9.98 0v6.57z"></path><path fill="#b33254" d="M2.31 29.66H61.7v3.32H2.31z"></path><path fill="#7ca3c2" d="M2.31 32.98H61.7V64H2.31z"></path><path fill="#5e5e61" d="M18.88 32.98h26.24v23.64H18.88z"></path><path fill="#d3d3d3" d="M20.06 32.98h-6.89v1.38c0 .52.42.95.95.95h5c.52 0 .95-.42.95-.95v-1.38zm-.95 21.31h-5a.95.95 0 0 0-.95.95v1.38h6.89v-1.38a.929.929 0 0 0-.94-.95z"></path><path fill="#e1e2e0" d="M14.35 35.31h4.53v18.98h-4.53z"></path><path fill="#d3d3d3" d="M35.45 32.98h-6.89v1.38c0 .52.42.95.95.95h5c.52 0 .95-.42.95-.95v-1.38zm-.95 21.31h-5a.95.95 0 0 0-.95.95v1.38h6.89v-1.38a.935.935 0 0 0-.94-.95z"></path><path fill="#e1e2e0" d="M29.74 35.31h4.53v18.98h-4.53z"></path><path fill="#d3d3d3" d="M50.83 32.98h-6.89v1.38c0 .52.42.95.95.95h5c.52 0 .95-.42.95-.95v-1.38zm-.95 21.31h-5a.95.95 0 0 0-.95.95v1.38h6.89v-1.38a.929.929 0 0 0-.94-.95z"></path><path fill="#e1e2e0" d="M45.12 35.31h4.53v18.98h-4.53zM8.73 56.62h46.53v3.69H8.73z"></path><path fill="#f2f2f2" d="M8.73 26.33h46.53v6.65H8.73z"></path><path fill="#d3d3d3" d="M5.83 60.31h52.34V64H5.83z"></path><path fill="#da4765" d="M32 12.21 8.73 26.33h46.54z"></path><path fill="#f9f9f9" d="M31.72 20.84v2.91a3.196 3.196 0 0 1-2.91-2.91h2.91zm0-3.46v2.91h-2.91a3.223 3.223 0 0 1 2.91-2.91z"></path><path fill="#b33254" d="M32 16.82c-2.07 0-3.75 1.68-3.75 3.75s1.68 3.75 3.75 3.75c2.07 0 3.75-1.68 3.75-3.75s-1.68-3.75-3.75-3.75zm-.28 6.93a3.196 3.196 0 0 1-2.91-2.91h2.91v2.91zm0-3.46h-2.91a3.196 3.196 0 0 1 2.91-2.91v2.91zm.56-2.91c1.54.13 2.78 1.36 2.91 2.91h-2.91v-2.91zm0 6.37v-2.91h2.91a3.205 3.205 0 0 1-2.91 2.91z"></path><path fill="#f9f9f9" d="M35.19 20.84a3.205 3.205 0 01-2.91 2.91v-2.91h2.91zm0-.55h-2.91v-2.91c1.54.14 2.77 1.37 2.91 2.91zM53.92 37.86h4.68v4.68h-4.68zM53.92 47.06h4.68v4.68h-4.68zM5.4 37.86h4.68v4.68H5.4zM5.4 47.06h4.68v4.68H5.4z"></path></svg>
        ),
        date: "March 2023",
        link: "https://www.coursera.org/account/accomplishments/certificate/EKHXP6GVHABS"
    },
    {
        label: "Accelerating End-to-End Data Science Workflows",
        icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="nvidia"><g fill="#4CAF50"><path d="M6.025 5.909c1.334 0 2.55 1.032 2.601 1.076a.5.5 0 0 1-.651.759c-.01-.008-.99-.834-1.95-.834-.008-.001-.017.002-.025.002v2.072c.206.062.426.106.675.106 1.428 0 3.116-1.151 4.129-2.037C9.674 6.123 7.754 5 6.35 5c-.114 0-.232.014-.35.028v.883l.025-.002z"></path><path d="M15.5 2h-9a.5.5 0 0 0-.5.5v1.525c.117-.011.234-.025.35-.025 1.988 0 4.456 1.646 5.544 2.684.099.093.154.223.155.358s-.054.266-.15.361c-.281.275-2.814 2.688-5.225 2.688-.241 0-.463-.029-.675-.071v.925c.123.028.245.055.351.055 1.394 0 5.506-1.137 6.8-2.403a.5.5 0 0 1 .699.715C12.291 10.838 7.936 12 6.35 12c-.111 0-.233-.034-.35-.052V13.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5z"></path><path d="M4.367 7.527c.36-.243 1.002-.605 1.633-.615V5.911c-1.325.013-2.525 1.03-2.576 1.073a.499.499 0 0 0-.147.54c.032.096.747 2.107 2.723 2.496V8.985c-.896-.268-1.407-1.017-1.633-1.458z"></path><path d="M1.275 7.209c.36-.193.728-.402 1.097-.613C3.615 5.887 4.895 5.163 6 5.028V4.025c-1.341.124-2.753.921-4.123 1.703-.543.309-1.079.615-1.597.868a.502.502 0 0 0-.175.757C1.804 9.524 4.219 11.687 6 11.948v-1.003c-1.182-.263-3.072-1.75-4.725-3.736z"></path></g></svg>,
        date: "May 2022",
        link: "https://courses.nvidia.com/certificates/795c488d495a43598b81d8f8d3b570b3/"
    }
]

function Item(args) {
    return (
        <div className="skill_item mb-3 w-100">
            <div className="d-flex align-items-center gap-2 w-100 mb-2">
                <h5 className="m-0">{args.label}</h5>
                <i class={"devicon-"+args.icon}></i>
                <p className="ml-auto">{args.value+"%"}</p>
            </div>
            <p>{args.details}</p>
            <div className="progressbar"><div className={"bg"+args.color} style={{width: args.value+"%", height:"100%"}}></div></div>
        </div>
    )
}

function Category(args) {
    return (
        <div className="skill_category">
            <h4 className="mb-4">{args.label}</h4>
            <div className="sep mb-4"></div>
            {args.skills.map((skill) => {
                return <Item label={skill.label} icon={skill.icon} value={skill.value} details={skill.details} color={skill.color} />
            })}
        </div>
    )
}


function Certif(args) {
    return (
        <a
            className="certif d-flex align-items-center gap-3 py-3 px-4"
            href={args.link}
        >
            <div className="d-flex align-items-center justify-content-center">
                {args.icon}
            </div>
            <div>
                <h6>{args.label}</h6>
                <p>{args.date}</p>
            </div>
        </a>
    )
}


function Skill() {
    return (
        <div id="skill" className="section">
            <h2 className="mb-5">skills</h2>
            <div className="d-flex justify-content-between flex-wrap col-gap-2 row-gap-5 pb-5">
                {categories.map((cat) => {
                    return <Category label={cat.label} skills={cat.skills} />
                })}
            </div>
            {/* <h4 className="pt-5 mb-5">Certificates</h4> */}
            <div className="d-flex flex-column gap-2 pt-5 pb-5">
                <h4 className="mb-4">Certificates</h4>
                <div className="sep mb-4"></div>
                {certificates.map((certif) => {
                    return (
                        <Certif label={certif.label} icon={certif.icon} date={certif.date} link={certif.link}/>
                    )
                })}
                <p className="mt-5">
                    More certifications and Badges can be viewed on my <a href="https://www.linkedin.com/in/benjamin-stach-1bb3741b2"><strong>LinkedIn</strong></a> page.
                </p>

            </div>
        </div>
    );
}

export default Skill;